import { render, staticRenderFns } from "./TheAdminMain.vue?vue&type=template&id=cc0d4c82&"
import script from "./TheAdminMain.vue?vue&type=script&lang=js&"
export * from "./TheAdminMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports